export const processStateFilterValues = [
    "",
    "ACTIVE",
    "SUSPENDED",
    "COMPLETED",
    "STATE_EXTERNALLY_TERMINATED",
    "STATE_INTERNALLY_TERMINATED",
    "HAS_INCIDENTS",
] as const;

export type ProcessStateFilter = typeof processStateFilterValues[number];

export interface ProcessListSearch {
    page?: number;
    size?: number;
    q?: string;
    state?: ProcessStateFilter;
    startTimeFrom?: string;
    startTimeTo?: string;
    endTimeFrom?: string;
    endTimeTo?: string;
    incidentTimeFrom?: string;
    incidentTimeTo?: string;
    dashboardScope?: boolean;
    category?: string;
    processDefinitionId?: string;
    processDefinitionKey?: string;
    orderBy?: string;
    order?: "asc" | "desc";
}

export function buildProcessQueryParams(search: ProcessListSearch) {
    const params = new URLSearchParams();
    params.set("page", String((search.page || 1) - 1));
    params.set("size", String(search.size || 10));
    params.set("sort", `${search.orderBy || "startTime"},${search.order || "desc"}`);

    if (search.q) params.set("q", search.q);
    if (search.state === "HAS_INCIDENTS") {
        params.set("hasIncidents", "true");
    } else if (search.state) {
        params.set("state", search.state);
    }
    if (search.category) {
        params.set("category", search.category);
        params.set("byCategory", search.category);
    }
    if (search.processDefinitionId) params.set("processDefinitionId", search.processDefinitionId);
    if (search.processDefinitionKey) params.set("processDefinitionKey", search.processDefinitionKey);
    if (search.startTimeFrom) params.set("startTimeFrom", toLocalDateBoundary(search.startTimeFrom, false));
    if (search.startTimeTo) params.set("startTimeTo", toLocalDateBoundary(search.startTimeTo, true));
    if (search.endTimeFrom) params.set("endTimeFrom", toLocalDateBoundary(search.endTimeFrom, false));
    if (search.endTimeTo) params.set("endTimeTo", toLocalDateBoundary(search.endTimeTo, true));
    if (search.incidentTimeFrom) params.set("incidentTimeFrom", toLocalDateBoundary(search.incidentTimeFrom, false));
    if (search.incidentTimeTo) params.set("incidentTimeTo", toLocalDateBoundary(search.incidentTimeTo, true));
    if (search.dashboardScope) params.set("dashboardScope", "true");

    return params.toString();
}

export function toLocalDateBoundary(date: string, endOfDay: boolean) {
    return new Date(`${date}T${endOfDay ? "23:59:59.999" : "00:00:00"}`).toISOString();
}
